import { Injectable } from '@angular/core';
import { Observable, first, map, of, switchMap, take } from 'rxjs';
import { APIResponse, PagedOffers } from '../models/deals/pagedOffers';
import { AuthorizedApiService, CommonService } from '@laasy/common-layout';
import { HotelCashbackAwareness } from '../models/homePageData';
import { ShopService } from '@laasy/common-layout/shop';
import { DatePipe } from '@angular/common';
import { Banner } from '@laasy/common-layout/home/model';
import { topHotelCard } from '../utilities/constants';
@Injectable({
  providedIn: 'root'
})
export class HomeService {
  constructor(private datePipe: DatePipe,private readonly apiService: AuthorizedApiService,private shopApiService:ShopService,private commonService:CommonService) {}

  getCustomAndExclusiveOffers(): Observable<APIResponse<PagedOffers>> {
    return this.apiService.getAndCache<APIResponse<PagedOffers>>(
      'offers/api/offers/exclusiveOffers'
    );
  }

  getHotelCashbackAwareness(): Observable<APIResponse<HotelCashbackAwareness>> {
    return this.apiService.getAndCacheWithLocal<APIResponse<HotelCashbackAwareness>>(
      'tenant/api/home/topHotelData',false,24*60*60);
  }

  getCollections(): Observable<any[]>{
    const userPref$ = this.shopApiService.getUserPrefCollections()
    return userPref$
    .pipe(
      map((resp: any) => {
        const collectionList:any[]  = [];
        resp.forEach((item:any) => {
          if (item.isCard) {
            const lastEl = collectionList[collectionList?.length - 1];
            if (lastEl?.isCard) {
              lastEl.cardList.push(item);
            } else {
              collectionList.push({
                isCard: true,
                cardList: [item]
              });
            }
          } else {
            collectionList.push(item);
          }
          });
          return collectionList;
        }))
  }

  getTopMerchants(): Observable<any> {
    return this.shopApiService.getTopMerchants()
  }

  getTopBrands(): Observable<any> {
    return this.shopApiService.getTopBrands()
  }

  getCustomization(): Observable<any> {
    return this.commonService.getCustomization().pipe(
      take(1),
      map(data => {
        const Customization = JSON.parse(data?.data?.[0]?.homeLayoutCustomization ?? '{}');
        return Customization;
      })
    );
  }

  getOnBoardingModalAssetData(activeProducts: string[]): Observable<any> {
    return this.apiService.getAndCache(
      location.origin + '/assets/json/onBoardingModalConfig.json'
    ).pipe(first());
  }

  getOnBoardingModalData(activeProducts: string[]): Observable<any> {
    return this.getCustomization().pipe(
      map(data =>  data['OnboardingModal'] ?? []),
      switchMap((data: any[]) => {
        if (!data.length) {
          return this.getOnBoardingModalAssetData(activeProducts);
        }
        return of(data);
      }),
      map((data: any[]) => {
        const filteredData = data.filter((item: any) => activeProducts.includes(item?.id?.toLowerCase()));
        return filteredData;
      }),
      map((response: any) => response.sort((a: any, b: any) => a.rank - b.rank)),
    );
  }

  getHeroBanner(activeProducts:string[]): Observable<Banner[]> {
    return this.getCustomization().pipe( map(data => {
      const activeBanner = data['heroBanner']?.filter((x: any) => activeProducts.includes(x?.id?.toLowerCase()))
      const transformedData = activeBanner?.map((x: any) => {
        return {
          prefix_text_underlined: '',
          post_text_underlined: x?.title, ...x
        }
      })
      if (!transformedData?.length) return []
      return transformedData.sort((a: any, b: any) => a?.rank - b?.rank)
    }))
  }

}
